import { useCallback } from "react";
import { TriangleAlert } from "lucide-react";
import { useBeforeUnload, useBlocker } from "react-router-dom";

import DialogCustom from "@/components/modals/dialog-custom";
import { Button } from "@/components/ui/button";

interface BlockerProps {
  blocked: boolean;
}

// NOTE : react-router-dom only support one blocker at a time
const Blocker = ({ blocked }: BlockerProps) => {
  const useBeforeUnloadCallback = useCallback(
    (event: BeforeUnloadEvent) => {
      if (!blocked) return;
      event.preventDefault();
      event.returnValue = "";
      return "";
    },
    [blocked]
  );

  // block refresh -- no custom message or dialog
  useBeforeUnload(useBeforeUnloadCallback);

  const blocker = useBlocker(() => blocked === true);

  const isBlocked = blocker.state === "blocked";

  return (
    <DialogCustom
      title="Vous quittez la page"
      open={isBlocked}
      onOpenChange={() => isBlocked && blocker.reset()}
      className="p-6"
      startIcon={<TriangleAlert className="w-10 h-10 -ml-4" color="#B91C1C" />}
    >
      <p>
        Vous avez des modifications non sauvegardées, êtes-vous sûr de vouloir
        quitter la page ?
      </p>
      <div className="flex justify-end gap-4">
        <Button variant="outline" onClick={() => isBlocked && blocker.reset()}>
          Non
        </Button>
        <Button onClick={() => isBlocked && blocker.proceed()}>Oui</Button>
      </div>
    </DialogCustom>
  );
};

export default Blocker;
